import React, { useEffect, useState } from "react";
import { api } from "../../app/Api/ApiSlice";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

const StoreUserCarts = () => {
    const [userCarts, setUserCarts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { name } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const getCarts = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/${name}/carts`);
                setUserCarts(response.data || []);
            } catch (error) {
                toast.error(error.response?.data?.message || "Error fetching carts");
            } finally {
                setIsLoading(false);
            }
        };

        getCarts();
    }, [name]);

    return (
        <div className="store-user-carts-list">
            <h5>My Carts in {name}</h5>

            {isLoading && <Loader />}

            {!isLoading && userCarts.length === 0 && (
                <p className="not-found-msg">
                    You have not created a cart in this store
                </p>
            )}

            {userCarts.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>Cart Name</th>
                            <th>Description</th>
                            <th>Items</th>
                            <th>Orders</th>
                            <th>Cart Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userCarts.map(cart => (
                            <tr
                                key={cart._id}
                                onClick={() =>
                                    navigate(`/b/${name}/carts/${cart._id}`)
                                }
                            >
                                <td>{cart.name}</td>
                                <td>{cart.description || "no description"}</td>
                                <td>{cart.productsCount}</td>
                                <td>{cart.orders}</td>
                                <td>{cart.totalValue}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default StoreUserCarts;
